import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_billingtasks_by_accessorial_taskIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { taskId: number }): 
  Promise<{ result: { Id?: number, Amount?: number, Cancelled?: boolean, CancelledReasonCodeId?: number, BillingRecord?: { ApplicableRate?: number, Total?: number, InvoiceLine?: { Id?: number, InvoiceId?: number, Invoice?: { LookupCode?: string } } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { taskId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Amount?: number, Cancelled?: boolean, CancelledReasonCodeId?: number, BillingRecord?: { ApplicableRate?: number, Total?: number, InvoiceLine?: { Id?: number, InvoiceId?: number, Invoice?: { LookupCode?: string } } } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { taskId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Amount?: number, Cancelled?: boolean, CancelledReasonCodeId?: number, BillingRecord?: { ApplicableRate?: number, Total?: number, InvoiceLine?: { Id?: number, InvoiceId?: number, Invoice?: { LookupCode?: string } } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      taskId: number    }) {
        if(isNil($inParams.taskId)) {
          return true; 
        }
      return false;
    }
}
